import { ITextProps, Text } from '../Text/Text';

import { convertHtmlToReactElement } from './helpers';

interface IProps {
  html: string;
  variant?: ITextProps['variant'];
}

export const TextFromHTML = ({ html, variant = 'md' }: IProps) => (
  <Text as="span" variant={variant} style={{ wordBreak: 'break-word' }} className="mb-0">
    {convertHtmlToReactElement(html)}
  </Text>
);
